<template>
  <div class="container-iconos">
      <div class="container container-fade">
        <div class="row mt-5 justify-content-center">
          <div class="col-7 col-md-2">
            <div class="text-center">
              <span class="d-block"><img width="100%" :src="`${publicPath}assets/images/iconos.png`" /></span>
            </div>
          </div>
          <div class="col-7 col-md-2">
            <div class="text-center">
              <span class="d-block mb-2"><img width="100%" :src="`${publicPath}assets/images/logo-univisionarios-tm.png`" /></span>
              <h2 class="text-md-left text-center">ÍCONOS</h2>
              <div class="mb-3"><img width="120px" :src="`${publicPath}assets/images/estrellas-blancas.png`" /></div>
            </div>
          </div>
          <div class="col-11 col-md-7 offset-md-1">
            <div class="iconos-text text-center text-md-left">Esta categoría reconoce a esas grandes estrellas y personajes que rompen las barreras porque su voz, imagen o acciones positivas cautivan al mundo entero. Artistas y personalidades que tienen una visión clara de cómo se puede mejorar nuestro mundo, y que dedican su tiempo y esfuerzo a promover los derechos y una mejor vida para su comunidad o el mundo.</div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 mb-3">
            <div class="line-top mt-3"></div>
          </div>
          <div class="col-12 col-md-9 text-center">
            <NominadosIconos :nominados="nominados" />
          </div>
        </div>
      </div>
    </div>
</template>

<style>

  .line-top {
    width: 100%;
    height: 1px;
    background: #a48c60;
  }

  .headline-iconos {
    color: #fff;
    font-family: var(--app-header-font);
    font-size: 4em;
  }

  .iconos-picture {
    width: 100%;
    max-width: 380px;
  }

  .iconos-text {
    font-family: "Roboto", sans-serif;
    font-size: 17px;
    font-weight: 300;
    color: #fff;
    text-align: left;
  }
</style>

<script>

import NominadosIconos from '@/components/NominadosIconos'
import filter from 'lodash/filter'

export default {
  name: 'Iconos',
  components: {
    NominadosIconos
  },
  props: {
    nominados_list: []
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    nominados() {
      return filter(this.nominados_list, ['category_id', 'iconos'])
    }
  }
}
</script>
